<!--采购信息模块-->
<template>
  <div class="details_content_repeat_hundred">
    <el-form label-width="102px">
      <column-box :source="baseInfo" :list="baseInfoList">
        <el-form-item
          :label="'合同附件' + columnSeparator"
          prop="contractAttachment"
          class="enclosure alone"
        >
          <div v-if="baseInfo.contractAttachment && baseInfo.contractAttachment.length > 0">
            <div
              v-for="(item, index) in baseInfo.contractAttachment"
              :key="'baseInfo' + index"
              class="uptext"
            >
              <p v-down="{ url: item.url, name: item.name }" class="blue">
                <i class="el-icon-document blue"></i>
                {{ item.name }}
              </p>
            </div>
          </div>
          <div v-else>--</div>
        </el-form-item>
      </column-box>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'PurchaseBaseInfo',
  props: {
    baseInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      baseInfoList: [
        {
          key: 'id',
          name: '采购订单ID',
        },
        {
          key: 'purchaseMode',
          name: '采购方式',
        },
        {
          key: 'state',
          name: '采购订单状态',
        },
        {
          key: 'providerName',
          name: '车源方',
        },
        {
          key: 'providerId',
          name: '车源方ID',
        },
        {
          key: 'gmtCreate',
          name: '订单创建时间',
        },
        {
          key: 'contractStartDate',
          name: '合同开始日期',
        },
        {
          key: 'contractEndDate',
          name: '合同结束日期',
        },
        {
          key: 'contractNo',
          name: '业务合同编号',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__content {
  margin-left: 0 !important;
}
.uptext {
  .blue {
    color: #2e7eff;
    display: inline-block;
    margin: 0;
  }
}
</style>
